export interface AddressFilterType {
  city: string
  postalCode: string
  countries: server.dto.Country[]
  regions: server.dto.Region[]
  states: server.dto.State[]
  filterType: server.dto.AddressFilterTypes
}

export const getSortedRegionLabels = (filter: AddressFilterType): string[] => {
  return filter.regions.map(r => r.text).sort((a, b) => a.localeCompare(b));
};

export const getSortedCountryLabels = (filter: AddressFilterType): string[] => {
  return filter.countries.map(c => c.name).sort((a, b) => a.localeCompare(b));
};

export const getSortedStatesLabels = (filter: AddressFilterType): string[] => {
  return filter.states.map(s => s.name || RESX.GeneralLabels.NotSpecified).sort((a, b) => a.localeCompare(b));
};

export const initialAddressFilter: AddressFilterType = {
  city: "",
  postalCode: "",
  countries: [],
  regions: [],
  states: [],
  filterType: "unknown"
};